import { useEffect } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '@/db/database';
import { drainOutbox } from '@/db/outbox';
import { useOnline } from './useOnline';

/** Live count of items waiting to send, and automatic draining whenever signal returns. */
export function useOutbox() {
  const { online } = useOnline();
  const count = useLiveQuery(() => db.outbox.count(), [], 0);

  useEffect(() => {
    if (online && count > 0) void drainOutbox();
  }, [online, count]);

  return { count, drain: drainOutbox };
}
